import Sentry from "@similarweb/sentry-logger";

import { TEAMS } from "app/constants/teamName";
import type { IRewardsOverviewResponse } from "app/pages/digital-suite/home-page/components/Rewards/utils/rewardsOverviewApi";
import { rewardsOverviewApi } from "app/pages/digital-suite/home-page/components/Rewards/utils/rewardsOverviewApi";
import type { IRewardsOverview } from "app/pages/digital-suite/home-page/components/Rewards/utils/types";

const getRawRewardsModalData = async (): Promise<IRewardsOverviewResponse | undefined> => {
    try {
        return await rewardsOverviewApi();
    } catch (error) {
        Sentry.error("Error fetching rewards data:", error, {
            tags: {
                team: TEAMS.HAWKS,
            },
        });
    }
};

const getTransformedRewardsData = async (): Promise<IRewardsOverview | undefined> => {
    try {
        const rewardsData = await getRawRewardsModalData();

        if (rewardsData?.Result) {
            return {
                ...rewardsData.Result,
                Packages: rewardsData.Result.Packages?.map((pkg) => ({
                    ...pkg,
                    DiscountPercentage: pkg.DiscountPercentage * 100,
                })),
            };
        }
        return undefined;
    } catch (error) {
        Sentry.error("Error transforming rewards data:", error, {
            tags: {
                team: TEAMS.HAWKS,
            },
        });
        return undefined;
    }
};

let rewardsOverviewPromise: Promise<IRewardsOverview | undefined> | null = null;

export const getMemoizedRewardsOverview = (): Promise<IRewardsOverview | undefined> => {
    if (!rewardsOverviewPromise) {
        rewardsOverviewPromise = getTransformedRewardsData().then((data) => {
            if (!data) {
                rewardsOverviewPromise = null;
            }
            return data;
        });
    }
    return rewardsOverviewPromise;
};
